<template>
    <div>
        <ul class="filter">
            <li class="filter__item" v-if="subjects.length > 1 && !prefilterSubject">
                <label for="subjectFilter" class="sr-only">{{ dictionary["PublicationsOverview.SubjectSelectLabel"]
                }}</label>
                <select id="subjectFilter" v-model="subject" :disabled="isLoading">
                    <option value="All">{{ dictionary["PublicationsOverview.SubjectSelectLabel"] }}</option>
                    <option v-for="subject in subjects" :key="subject.Key" :value="subject.Key">{{
                        subject.Name
                    }}
                    </option>
                </select>
            </li>

            <li class="filter__item" v-if="types.length > 1 && !prefilterType">
                <label for="typeFilter" class="sr-only">{{ dictionary["PublicationsOverview.TypeSelectLabel"] }}</label>
                <select id="typeFilter" v-model="type" :disabled="isLoading">
                    <option value="All">{{ dictionary["PublicationsOverview.TypeSelectLabel"] }}</option>
                    <option v-for="typeItem in types" :key="typeItem.Key" :value="typeItem.Key">{{
                        typeItem.Name
                    }}</option>
                </select>
            </li>

            <li class="filter__item" v-if="audiences.length > 1 && !prefilterAudience">
                <label for="typeFilter" class="sr-only">{{ dictionary["PublicationsOverview.AudienceSelectLabel"]
                }}</label>
                <select id="typeFilter" v-model="audience" :disabled="isLoading">
                    <option value="All">{{ dictionary["PublicationsOverview.AudienceSelectLabel"] }}</option>
                    <option v-for="audienceItem in audiences" :key="audienceItem.Key" :value="audienceItem.Key">{{
                        audienceItem.Name
                    }}</option>
                </select>
            </li>

            <li class="filter__item" v-if="hasFilterApplied">
                <button type="button" @click="resetFilter">{{ dictionary["PublicationsOverview.ResetFilter"] }}</button>
            </li>
        </ul>
        <ul class="publications-overview__list">
            <li class="publication-card__wrap" v-for="publication in publications" :key="publication.Url">
                <a :href="publication.Url" class="publication-card">
                    <div class="publication-card__image">
                        <ResponsiveImage v-if="publication.HasImageForVue" :imageModel="publication.ImageForVue" />
                    </div>
                    <div class="publication-card__content">
                        <p class="publication-card__title">{{ publication.Title }}</p>
                        <div class="publication-card__cta">
                            <div class="cta-arrow-with-text">
                                <span>{{ dictionary["PublicationOverview.CardCta"] }}</span>
                                <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" version="1.1">
                                    <!-- Generator: Adobe Illustrator 29.1.0, SVG Export Plug-In . SVG Version: 2.1.0 Build 142)  -->
                                    <g id="Group_544">
                                        <g id="Path_436">
                                            <path
                                                d="M23.8,6.1l-6.1,6.1-1.1-1.1,4.3-4.3H6.3C2.8,6.9,0,4.1,0,.6V.1h1.5v.4c0,2.7,2.2,4.8,4.8,4.8h14.6l-4.3-4.3,1.1-1.1,6.1,6.1Z" />
                                        </g>
                                    </g>
                                </svg>
                            </div>
                        </div>

                    </div>
                </a>
            </li>
        </ul>
        <div class="publications-overview__footer">
            <div class="publications-overview__no-publications" v-show="!publications.length && !isLoading">
                {{ dictionary["PublicationsOverview.NoResults"] }}
            </div>
            <div class="publications-overview__load-more" v-show="hasMorePublications">
                <a @click="getNextPage" :disabled="isLoading">{{ dictionary["PublicationsOverview.LoadMore"] }}</a>
            </div>
        </div>
    </div>
</template>

<script>
import { nextTick } from 'vue'
import { bindRoute } from "./mixins/bindroute.js";
import ResponsiveImage from "./components/responsiveImage.vue";


const serviceUrl = "/umbraco/api/publicationsApi/getPublications",
    defaultType = "All",
    defaultSubject = "All",
    defaultAudience = "All";

export default {
    name: "publicationsOverview",
    props: ["sourceNodeId", "prefilterSubject", "prefilterType", "prefilterAudience"],
    components: {
        ResponsiveImage
    },
    data() {
        return {
            dictionary: [],
            types: [],
            subjects: [],
            audiences: [],
            publications: [],
            pageSize: 8,
            totalPublications: 0,
            loadedPublications: 0,
            isLoading: false,
            hasLoadedInitials: false,
            isResetting: false
        };
    },
    mixins: [
        bindRoute({
            page: 1,
            query: null,
            type: defaultType,
            subject: defaultSubject,
            audience: defaultAudience
        }),
    ],
    watch: {
        page: {
            handler(oldVal, newVal) {
                this.handleFilterPropertyChange(oldVal, newVal, false, true);
            }
        },
        query: {
            handler(newVal, oldVal) {
                clearTimeout(queryTimer);
                queryTimer = setTimeout(() => {
                    this.handleFilterPropertyChange(oldVal, newVal, true, false);
                }, 750);
            }
        },
        type: {
            handler(oldVal, newVal) {
                this.handleFilterPropertyChange(oldVal, newVal, true, false);
            }
        },
        subject: {
            handler(oldVal, newVal) {
                this.handleFilterPropertyChange(oldVal, newVal, true, false);
            }
        },
        audience: {
            handler(oldVal, newVal) {
                this.handleFilterPropertyChange(oldVal, newVal, true, false);
            }
        }
    },
    mounted() {

        this.$router.isReady().then(() => {
            this.getInitialPublications();
        }).catch(error => {
            console.log(error);
        });
    },
    methods: {
        handleFilterPropertyChange(oldVal, newVal, resetPage = false, append = false) {
            if (oldVal !== newVal) {
                if (this.hasLoadedInitials && !this.isResetting) {
                    this.filterChanged(resetPage, append);
                }
            }
        },
        getPublications(amountToSkip, pageSize, append = false) {
            const vm = this,
                languageCode = document.querySelector("html").getAttribute("lang");
            vm.toggleSpinner(true);
            var object = {
                sourceNodeId: vm.sourceNodeId,
                languageCode: languageCode,
                amountToSkip: amountToSkip,
                pageSize: pageSize,
            };

            if (vm.prefilterSubject) {
                object.subject = vm.prefilterSubject;
            }
            else if (vm.subject != defaultSubject) {
                object.subject = vm.subject;
            }

            if (vm.prefilterType) {
                object.type = vm.prefilterType;
            }
            else if (vm.type != defaultType) {
                object.type = vm.type;
            }

            if(vm.prefilterAudience){
                object.audience = vm.prefilterAudience;
            }
            else if (vm.audience != defaultAudience) {
                object.aucience = vm.audience;
            }


            fetch(serviceUrl + "?" + new URLSearchParams(object))
                .then((response) => response.json())
                .then((data) => {

                    if (append) {
                        vm.publications.push(...data.Items);
                        vm.loadedPublications += data.Items.length;
                    } else {
                        vm.publications = data.Items;
                        vm.loadedPublications = data.Items.length;
                    }
                    vm.totalPublications = data.TotalItems;

                    vm.dictionary = data.Dictionary;
                    vm.subjects = data.Facets.Subjects;
                    vm.types = data.Facets.Types;
                    vm.audiences = data.Facets.Audiences;

                    nextTick(() => {
                        vm.hasLoadedInitials = true;
                        vm.toggleSpinner(false);
                        vm.isResetting = false;
                    });

                })
                .catch((error) => {
                    console.log(error);
                    vm.toggleSpinner(false);
                });
        },
        getNextPage() {
            if (!this.isLoading) {
                this.page++;
            }
        },
        getInitialPublications() {
            // Get all cases up to, and including, the current page
            this.getPublications(0, this.page * this.pageSize, true);

        },
        filterChanged(resetPage = false, append = false) {
            this.isResetting = true;
            if (!append || resetPage) {
                this.page = 1;
                this.getPublications(0, this.pageSize, append);
            } else {
                this.getPublications(this.pageSize * (this.page - 1), this.pageSize, append);
            }
        },
        resetFilter() {
            const vm = this;
            vm.isResetting = true;
            vm.publications = [];
            vm.totalPublications = 0;
            vm.loadedPublications = 0;
            vm.page = 1;

            if(!vm.prefilterSubject){
                vm.subject = defaultSubject;
            }

            if(!vm.prefilterType){
                vm.type = defaultType;
            }

            if(!vm.prefilterAudience){
                vm.audience = defaultAudience;
            }

            vm.$router.replace({ path: window.location.pathname, query: {} })
                .then(() => {
                    vm.getPublications(0, vm.pageSize);
                })
                .catch(err => { console.log(err); });
        },
        toggleSpinner: function (isLoading) {
            this.isLoading = isLoading;
            const bodyElement = document.querySelector("body");
            if (isLoading) {
                bodyElement.classList.add("is-loading");
            } else {
                bodyElement.classList.remove("is-loading");
            }
        },
    },
    computed: {
        hasMorePublications() {
            return (
                this.totalPublications !== 0 &&
                this.publications.length < this.totalPublications
            );
        },
        hasFilterApplied() {
            return (this.type != defaultType && !this.prefilterType) ||
                (this.subject != defaultSubject && !this.prefilterSubject) ||
                (this.audience != defaultAudience && !this.prefilterAudience);
        }
    },
};
</script>